import React, {Component} from 'react';

class BookmakerAd extends Component {
  disclaimer(bookie) {
    return bookie.legalDisclaimerText ? (
      <img className="eeep-image" src="https://betarades2-5c24.kxcdn.com/wp-content/themes/betarades/assets/images/eeep/eeep-desktop-bookmaker-ad.svg" height="73" width="40" alt="eeep disclaimer" loading="lazy" />
    ) : null;
  }

  loadTemplate(bookie) {
    return (
      <tr className="bookmaker-ad-row">
        <td colSpan="17">
          <a
            href={bookie.affLink}
            target="_blank"
            style={{background: bookie.bgColor}}
            rel="noopener noreferrer"
          >
            <figure>
              <img loading="lazy" src={bookie.logo} alt={bookie.name + "'s logo"} width="60" height="60"/>
            </figure>
            <span style={{color: bookie.textColor}}>{bookie.text}</span>
            <button type="button" className={bookie.legalDisclaimerText ? 'has-disclaimer' : ''}>
              {bookie.actionText ? bookie.actionText : 'ΕΓΓΡΑΦΗ'}
            </button>
            {this.disclaimer(bookie)}
          </a>
        </td>
      </tr>
    )
  }

  render() {
    const kouponiRoot = document.getElementById('app-external') || document.getElementById('app');
    const dataAds = kouponiRoot.getAttribute('data-ads') || "";

    if (!dataAds) {
      return ''
    }

    let ads = [];

    try {
      ads = JSON.parse(dataAds);
      const luckyBookie = ads[Math.floor(Math.random() * ads.length)];
      return this.loadTemplate(luckyBookie);
    } catch (_) {
      console.log("The 'data-ads' attribute's value is not valid json");
      return '';
    }
  }
}

export default BookmakerAd;



// WEBPACK FOOTER //
// ./src/Components/BookmakerAd.js